import { render, staticRenderFns } from "./AdvertisingDialog.vue?vue&type=template&id=cd447f78&scoped=true&"
import script from "./AdvertisingDialog.vue?vue&type=script&lang=js&"
export * from "./AdvertisingDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingDialog.vue?vue&type=style&index=0&id=cd447f78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd447f78",
  null
  
)

export default component.exports